
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
import { param } from 'jquery'
// 文件上传
export const fileUpload =
  process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/upload'
// 导入政策
export const importPolicyData = params => request.post(BASE_URL + '/govPolicy/importPolicyData', params)
// 政策管理查询分页
export const getPolicyDataByPage = params => request(BASE_URL + '/govPolicy/getPolicyDataByPage', { params })
// 政策详情查询
export const getPolicyData = params => request(BASE_URL + '/govPolicy/getPolicyData', { params })
// 编辑政策
export const updatePolicyData = params => request.post(BASE_URL + '/govPolicy/updatePolicyData', params)
// 删除政策
export const deletePolicyById = params => request(BASE_URL + '/govPolicy/deleteById', { params })
// 企业匹配查询
export const getEntDataPage = params => request(BASE_URL + '/govPolicy/getEntDataPage', { params })
// 导出企业
export const exportDataPage = params => request.downLoad(BASE_URL + '/govPolicy/exportEntData', params)
// 推送/新增企业
export const addEntDatas = params => request.post(BASE_URL + '/govPolicy/addEntDatas', params)

// 模板导出
export const downloadFile = (params, downCallBack) => request.downLoad(BASE_URL + '/govPolicy/downloadFile', params, '', '', downCallBack)
// 企业标签
export const getAllDictLabel = params => request(BASE_URL + '/dictLabel/getAllDictLabel', { params })

// 消息模板管理-消息模板分页列表
export const getSmsTemplateList = params => request(BASE_URL + '/smsTemplate/page', { params })
// 消息选择企业-添加企业不分页列表
export const findEntList = params => request(BASE_URL + '/goventDetail/findEntList', { params })
// 消息选择企业-分页列表查询
export const smsEntTempPage = params => request(BASE_URL + '/smsEntTemp/smsEntTempPage', { params })
// 消息选择企业-添加或一键添加企业
export const addSmsEntTemp = params => request.post(BASE_URL + '/smsEntTemp/addSmsEntTemp', params)
// 消息选择企业-政策中新增消息
export const addPolicySms = params => request.post(BASE_URL + '/smsEntTemp/addPolicySms', params)

// 获取进度接口
export const getMapProcess = params => request(BASE_URL + '/smsMessage/getMapProcess', { params })
// 消息选择企业-删除选择的企业
export const deleteSmsEntTemp = params => request(BASE_URL + '/smsEntTemp/deleteSmsEntTemp', { params })

// 保存编辑的区县和标签-删除选择的企业
export const updatePolicyDataById = params => request.post(BASE_URL + '/govPolicy/updatePolicyDataById', params)
